/* app/js/src/components/content-control/assets-hub/content-control-assets-hub/content-control-assets-hub-edit-cell/content-control-assets-hub-edit-cell.component.scss */
:host {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
/*# sourceMappingURL=content-control-assets-hub-edit-cell.component.css.map */
